import { CircleCheck, Droplet, Ellipsis, type LucideIcon } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

const statusStyles: Record<string, string> = {
  'Pending Analysis': 'bg-warning text-warning-foreground border !border-warning-foreground hover:bg-warning font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
  Analyzed: 'bg-purple text-purple-foreground border !border-purple-foreground hover:bg-purple font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
  'Ready for Backlog': 'bg-success text-success-foreground border !border-success-foreground hover:bg-success font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
  New: 'bg-new text-new-foreground border-1 !border-new-foreground hover:bg-new',
  'In Progress': 'bg-info text-info-foreground border-1 !border-info-foreground hover:bg-info',
  Completed: 'bg-success text-success-foreground border-1 !border-success-foreground hover:bg-success',
}


const statusIcons: Record<string, LucideIcon> = {
  New: Droplet,
  'In Progress': Ellipsis,
  Completed: CircleCheck,
}

export function WorkItemStatusBadge({ status }: { status: string }) {
  const Icon = statusIcons[status]
  return (
    <Badge
      variant="outline"
      data-testid={`work-item-status-${status}`}
      className={`gap-1 ${statusStyles[status] ?? 'bg-muted text-muted-foreground hover:bg-muted'}`}
    >
      {Icon && <Icon className="h-3.5 w-3.5" />}
      {status}
    </Badge>
  )
}
